export const BLOCK_PLACES = {
  recipePage: 'recipe-page',
  articlePage: 'article-page',
  mainContentArea: 'main-content-area',
  relatedContentArea: 'related-content-area',
  accordion: 'accordion',
};
